import React, { useState } from "react";
import { ArborescenceBâtimentaire } from "../actif_arborescence/ArborescenceBâtimentaire";
import { sitesSerivces } from "../../services";
import CustomDialog from "../CustomDialog";
import Loading from "../Loading";
import { useQuery } from "@tanstack/react-query";
import { Site } from "../../interfaces";
import ArborescenceSite from "./ArborescenceSite";

interface SiteStructureProps {
  modalIsOpenstrucuture: boolean;
  closeModalStructure: () => void;
  uuid: string;
}
const SiteStructure = ({
  modalIsOpenstrucuture,
  closeModalStructure,
  uuid,
}: SiteStructureProps) => {
  const [loading, setLoading] = useState(false);
  const { data: refSite } = useQuery<Site | null>({
    queryKey: ["site", uuid],
    queryFn: async () => {
      try {
        setLoading(true);
        const response = await sitesSerivces.getByUuid(uuid);
        setLoading(false);
        return response;
      } catch (error) {
        setLoading(false);
        throw new Error("Error fetching site data: " + error.message);
      }
    },
    enabled: !!uuid,
  });
  return (
    <>
      <CustomDialog
        visible={modalIsOpenstrucuture}
        closeModalDialog={closeModalStructure}
        header="Structure"
      >
        <div className="relative w-full h-full">
          <div className="p-6 space-y-6 overflow-auto max-h-[750px]">
            <div className="cursor-pointer hover:bg-gray-200 flex px-3 py-1 mr-72  font-semibold text-md text-black border border-gray-400  rounded-md ">
              <div className="flex space-x-3">
                <img src="/images/composants.png" className="w-6 h-6" />
                <span>{refSite?.nom_site} </span>
              </div>
            </div>
            {refSite?.batiments?.length === 0 ? (
              <>
                <div
                  className="flex items-center p-4 mb-4 text-sm text-yellow-800 rounded-lg bg-yellow-50 dark:bg-gray-800 dark:text-yellow-300"
                  role="alert"
                >
                  <svg
                    className="flex-shrink-0 inline w-4 h-4 mr-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
                  </svg>
                  <span className="sr-only">Info</span>
                  <div>
                    <span className="font-medium">
                      Ce site est pas encore stucturé. Ajouter des entités
                      géospatiales
                    </span>
                  </div>
                </div>
              </>
            ) : (
              <ArborescenceSite site={refSite} />
            )}
          </div>
        </div>
      </CustomDialog>
      {loading && <Loading />}
    </>
  );
};

export default SiteStructure;
